<p-table
  #table
  [value]="datasource"
  [columns]="selectedColumns"
  [scrollable]="true"
  scrollDirection="vertical"
  [rows]="rows"
  scrollHeight="flex"
  styleClass="p-datatable-sm p-datatable-gridlines p-datatable-striped"
  [globalFilterFields]="tableOptions.globalFilterFields"
  [filterDelay]="filterDelay"
  stateStorage="local"
  [stateKey]="statekey"
  [dataKey]="defaultSortField"
  [reorderableColumns]="true"
  selectionMode="single"
  [selection]="selectedData"
  (onRowSelect)="onRowSelect($event)"
  (onRowUnselect)="onRowUnselect($event)"
  [sortField]="defaultSortField"
  [sortOrder]="defaultSortOrder"
>
  <ng-template pTemplate="caption">
    <mx-table-caption>
      <div left>
        <ng-content select="[left]"></ng-content>
      </div>
      <div right class="inline-flex">
        <ng-content select="[right]"></ng-content>
        <mx-table-caption-button
          class="desktop-view"
          [visible]="refreshTableVisible"
          (onClick)="refreshData.emit()"
          [tooltip]="'button:Refresh'"
          [icon]="'fa fa-sync fa-fw'"
        >
        </mx-table-caption-button>
        <mx-table-search
          [visible]="globalSearchVisible"
          [(searchValue)]="globalSearchValue"
          (onModelChange)="onGlobalSearchValueChange($event)"
        >
        </mx-table-search>
      </div>
    </mx-table-caption>
  </ng-template>
  <ng-template pTemplate="header" let-columns>
    <tr
      mx-table-header
      [columns]="columns"
      [columnDefaultWidth]="columnDefaultWidth"
      [operationItems]="operationItems"
    ></tr>
  </ng-template>
  <ng-template
    pTemplate="body"
    let-rowData
    let-rowIndex="rowIndex"
    let-columns="columns"
  >
    <!-- <tr
  >{{rowIndex| json}}</tr> -->
    <!-- <td *ngFor="let col of columns">
    {{rowData[col.field]}}
</td> -->
    <tr
      mx-table-body
      [operationItems]="operationItems"
      [pSelectableRow]="rowData"
      [style]="
        'min-height: ' +
        rowHeight +
        'px; ' +
        'background: ' +
        (rowData | mxTableColoredRow: tableOptions.coloredRows)
      "
      [columns]="columns"
      [columnDefaultWidth]="columnDefaultWidth"
      [rowData]="rowData"
    ></tr>
  </ng-template>
  <ng-template pTemplate="loadingbody" let-columns="columns">
    <tr
      mx-table-loading-body
      [style]="'min-height: ' + rowHeight + 'px;'"
      [columns]="columns"
      [columnDefaultWidth]="columnDefaultWidth"
    ></tr>
  </ng-template>
  <ng-template pTemplate="emptymessage" let-columns>
    <tr
      mx-table-empty-message
      [style]="'min-height: ' + rowHeight + 'px;'"
      [columns]="columns"
    ></tr>
  </ng-template>
</p-table>

<p-confirmPopup></p-confirmPopup>
